<template>
  <div v-if="isAdmin"
    class="is-border-left is-border-right is-border-bottom">
    <div v-if="options && options.length" class="columns is-vcentered is-gapless is-padding-right is-border-bottom has-bg-light">
      <div class="column">
        <div class="is-tab-like is-tab-like--btnactivetransparent is-marginless-bottom columns">
          <a
            class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
            @click="selectTab('option')" :class="{'is-active': tab === 'option'}"
            v-if="runningOptions && runningOptions.length">En cours ({{runningOptions.length}})</a>
          <a
            class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
            @click="selectTab('proposal')" :class="{'is-active': tab === 'proposal'}"
            v-if="pastOptions && pastOptions.length">Historique ({{pastOptions.length}})</a>
        </div>
      </div>
    </div>
    <div v-if="options && options.length">
      <table
        class="table is-hoverable is-striped-v is-fullwidth is-first-fixed-xsmall is-marginless-bottom is-border-bottom is-border-top">
        <thead>
        <tr class="is-size-6">
          <th>Statut</th>
          <th>Lot</th>
          <th>Société</th>
          <th>Vendeur</th>
          <th>Contact</th>
          <th>Date de création</th>
        </tr>
        </thead>
        <tbody>
        <tr class="is-border-top is-size-6" v-for="option in currentOptions" :key="option.pk">
          <td class="has-text-centered">
              <span class="dot tooltip" :class="option.status|dotClass"
                    :data-tooltip="optionStatus[option.status].label"></span>
          </td>
          <td class="is-cell-hoverable">
            <router-link :to="{name: 'LotVue', params: {id: option.lot.pk || option.lot}}" class="fullLink">
              {{option.lot_ref}}
            </router-link>
          </td>
          <td>
            <router-link v-if="option.company" :to="{name: 'CompanyVue', params: {id: option.company}}">
              {{option.company_name}}
            </router-link>
            <span v-else>--</span>
          </td>
          <td class="is-cell-hoverable">
            <router-link :to="{name: 'UserVue', params: {id: option.seller}}">
              {{option.seller_name}}
            </router-link>
          </td>
          <td class="is-cell-hoverable">
            <router-link :to="{name: 'ContactVue', params: {id: option.buyer}}">
              {{option.buyer_name}}
            </router-link>
          </td>
          <td>
            <span>
              {{ option.created_on | prettyDatetime }}
            </span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="column">
      <em><b>Aucune option.</b></em>
    </div>
  </div>
</template>

<script>
  import { OptionStatus, DefaultValues } from '../../../mixins'
  import { mapGetters } from 'vuex'

  export default {
    name: 'ProgramOptionList',
    mixins: [OptionStatus, DefaultValues],
    data () {
      return {
        tab: 'option'
      }
    },
    props: {
      options: {
        type: Array,
        required: true
      }
    },
    computed: {
      ...mapGetters(['isAdmin']),
      currentOptions () {
        if (this.tab === 'option') {
          return this.runningOptions
        } else {
          return this.pastOptions
        }
      },
      runningOptions () {
        let okStatus = ['pending', 'approved', 'waiting_list']
        return this.options.filter(x => {
          return okStatus.includes(x.status)
        })
      },
      pastOptions () {
        let okStatus = ['refused', 'expired', 'canceled_by_admin', 'canceled_by_seller']
        return this.options.filter(x => {
          return okStatus.includes(x.status)
        })
      }
    },
    methods: {
      selectTab (value) {
        this.tab = value
      }
    },
    created () {
      if (this.currentOptions.length > 0) {
        this.tab = 'option'
      } else {
        this.tab = 'proposal'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/program/Tabs/ProgramOptionList.vue